"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': 'Tutorial-Statistiken',
    'tutorial.statistics.details': 'Teilnehmer und Tutorial-Fortschritt',
    'tutorial.statistics.subtitle': 'Wähle ein Tutorial, um den Fortschritt der Teilnehmer anzuzeigen.',
    'tutorial.statistics.tutorial': 'Tutorial',
    'tutorial.statistics.category': 'Kategorie',
    'tutorial.statistics.actions': 'Aktionen',
    'tutorial.statistics.viewParticipants': 'Teilnehmer anzeigen',
    'tutorial.statistics.search': 'Suchen',
    'tutorial.statistics.retry': 'Erneut versuchen',
    'tutorial.statistics.refresh': 'Aktualisieren',
    'tutorial.statistics.back': 'Zurück zu den Tutorials',
    'tutorial.statistics.pagination': 'Tutorial-Seiten',
    'tutorial.statistics.previous': 'Vorherige',
    'tutorial.statistics.next': 'Nächste',
    'tutorial.statistics.participants': 'Teilnehmer',
    'tutorial.statistics.participant': 'Teilnehmer',
    'tutorial.statistics.identity': 'Teilnehmertyp',
    'tutorial.statistics.registered': 'Registrierter Benutzer',
    'tutorial.statistics.guest': 'Gast',
    'tutorial.statistics.currentStep': 'Zuletzt gespeicherter Schritt',
    'tutorial.statistics.currentSection': 'Zuletzt gespeicherter Abschnitt',
    'tutorial.statistics.tasks': 'Abgeschlossene Aufgaben',
    'tutorial.statistics.progress': 'Fortschritt',
    'tutorial.statistics.progressExplanation': 'Der Fortschritt ist der Anteil der abgeschlossenen Tutorial-Aufgaben pro Teilnehmer. Die gespeicherte Position bedeutet keinen Abschluss.',
    'tutorial.statistics.notStarted': 'Keine gespeicherte Position',
    'tutorial.statistics.noTasks': 'Keine Aufgaben',
    'tutorial.statistics.emptyTutorials': 'Keine Tutorials gefunden.',
    'tutorial.statistics.emptyParticipants': 'Dieses Tutorial hat noch keine Teilnehmer.',
    'tutorial.statistics.loadFailed': 'Tutorial-Statistiken konnten nicht geladen werden.',
    'tutorial.statistics.time_data': 'Zeitdaten des Tutorial-Teilnehmers',
    'tutorial.statistics.viewTimeData': 'Zeitdaten anzeigen',
    'tutorial.statistics.time': 'Zeit im Abschnitt',
};
